import { t } from "i18next";

import Star from "@/assets/icons/star.svg?react";
import { AirdropStatus } from "@/interfaces/store";

import styles from "./styles";

export const StatusBadge = ({ status }: { status: AirdropStatus }) => {
  switch (status) {
    case "soon":
    case "preActive":
      return (
        <styles.Badge $status={status}>
          <p>{t("Airdrop.ComingSoon")}</p>
          <Star />
          <Star />
        </styles.Badge>
      );

    case "closed":
      return (
        <styles.Badge $status={status}>
          <p>{t("Airdrop.AirdropIsOver")}</p>
        </styles.Badge>
      );

    default:
      return null;
  }
};
